"use client";
import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { resolveTextColor } from "../../typography/typography.helpers.js";
import { alpha, Box, Paper, Table as Table$1 } from "@mantine/core";
import { forwardRef, Children } from "react";
import { useCustomHeaders, useGeneratedHeaders, renderChildrenWithLabels } from "./Table.helper.js";
import TableTdWrapper from "./TableTdWrapper.js";
import '../../../assets/Table.css';const container = "_container_ng8mt_2";
const table = "_table_ng8mt_18";
const caption = "_caption_ng8mt_139";
const TableStyles = {
  container,
  table,
  caption
};
const _Table = forwardRef((props, ref) => {
  const {
    items,
    bottomCaption,
    children,
    variant = "dark",
    striped,
    hideCardLabels = false,
    highlightOnHover = false,
    scrollable,
    style,
    mod,
    ...rest
  } = props;
  const styleVariables = {
    "--passed-text": resolveTextColor(variant),
    "--passed-striped-color": variant === "dark" ? alpha("var(--figurine-body-white)", 0.5) : alpha("var(--figurine-body-dark)", 0.5)
  };
  const customHeaders = useCustomHeaders(children);
  const generatedHeaders = useGeneratedHeaders(items, children);
  const headers = customHeaders || generatedHeaders;
  const safeChildren = Children.toArray(children);
  const renderedChildren = renderChildrenWithLabels(safeChildren, headers, hideCardLabels);
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ...rest,
      ref,
      style: { ...styleVariables, ...style },
      mod: { variant, striped, ...mod },
      children: [
        /* @__PURE__ */ jsx(
          Paper,
          {
            className: TableStyles.container,
            p: 0,
            mt: "sm",
            mod: { scrollable, ...mod },
            children: /* @__PURE__ */ jsxs(Table$1, { highlightOnHover, className: TableStyles.table, children: [
              !children && headers && /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsx(Table$1.Thead, { children: /* @__PURE__ */ jsx(Table$1.Tr, { children: headers.map((header, index) => /* @__PURE__ */ jsx(Table$1.Th, { children: header }, index)) }) }),
                /* @__PURE__ */ jsx(Table$1.Tbody, { children: items == null ? void 0 : items.map((item, rowIndex) => /* @__PURE__ */ jsx(Table$1.Tr, { children: headers == null ? void 0 : headers.map((header, colIndex) => /* @__PURE__ */ jsx(
                  TableTdWrapper,
                  {
                    hideCardLabels,
                    header,
                    children: item[header]
                  },
                  `tr${rowIndex}td${colIndex}`
                )) }, rowIndex)) })
              ] }),
              children && renderedChildren
            ] })
          }
        ),
        bottomCaption && /* @__PURE__ */ jsx("div", { className: TableStyles.caption, children: bottomCaption })
      ]
    }
  );
});
const Table = sharedHandler(_Table);
Table.displayName = "Table";
Table.Thead = Table$1.Thead;
Table.Tr = Table$1.Tr;
Table.Th = Table$1.Th;
Table.Tbody = Table$1.Tbody;
Table.Td = Table$1.Td;
Table.Tfoot = Table$1.Tfoot;
export {
  TableStyles as T,
  Table as default
};
